import React from 'react';
import { Outlet, Link } from 'react-router-dom';
import { Box, AppBar, Toolbar, Typography, Container, Paper } from '@mui/material';
import ThemeToggle from '../ThemeToggle';
import { useTheme } from '../../contexts/ThemeContext';
import { BscWebSocketProvider } from '../../contexts/BscWebSocketContext';
import './styles.css';

const Layout: React.FC = () => {
  const { theme } = useTheme();
  
  return (
    <Box sx={{ 
      display: 'flex', 
      flexDirection: 'column', 
      minHeight: '100vh',
      bgcolor: theme.palette.background.default,
      color: theme.palette.text.primary,
      transition: 'all 0.3s ease',
    }}>
      <AppBar position="static" color="primary" elevation={0}>
        <Toolbar>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1, fontWeight: 'bold' }}>
            批量swap工具
          </Typography>
          {/* <Box sx={{ display: 'flex', gap: 2 }}>
            <Link to="/" style={{ color: 'inherit', textDecoration: 'none' }}>首页</Link>
            <Link to="/bsc-swap" style={{ color: 'inherit', textDecoration: 'none' }}>BSC批量交换</Link>
            <Link to="/dex-config" style={{ color: 'inherit', textDecoration: 'none' }}>DEX配置</Link>
            <Link to="/dex-tester" style={{ color: 'inherit', textDecoration: 'none' }}>DEX测试工具</Link>
          </Box> */}
          <ThemeToggle />
        </Toolbar>
      </AppBar>
      <BscWebSocketProvider wsUrl="wss://wsdexpri.okx.com/ws/v5/public">
        <Container component="main" sx={{ 
          flex: 1, 
          py: 3,
          display: 'flex',
          flexDirection: 'column', 
        }}>
          <Outlet />
        </Container>
      </BscWebSocketProvider>
    </Box>
  );
};

export default Layout;
